// extracted by mini-css-extract-plugin
export default {"ecs":"ECSSidebar__ecs__hRWLP"};